<template>
  <div>
    <PageHeader :title="$t('Claims')" />
    <TabsNavigation :tabs="tabs" />
  </div>
</template>

<script>
import { PageHeader, TabsNavigation } from "@estaly/ui";

export default {
  components: { TabsNavigation, PageHeader },

  data() {
    return {
      tabs: [
        { name: "claims", displayName: "Sinistres", path: "/platform/claims" },
        { name: "claim_invoices", displayName: "Factures sinistres", path: "/platform/claim_invoices" },
      ],
    };
  },
};
</script>
